import angular from 'angular';
import mainMenuMobileComponent from './mainMenuMobile.component';
import devChangeEmployeeMobile from './devChangeEmployeeMobile/devChangeEmployeeMobile';
import MainMenuMobileBehaviourService from './mainMenuMobileBehaviour.service';

let mainMenuMobileModule = angular.module('mainMenuMobile', [
  devChangeEmployeeMobile
])

  .component('mainMenuMobile', mainMenuMobileComponent)

  .service('mainMenuMobileBehaviourService', MainMenuMobileBehaviourService)

  .name;

export default mainMenuMobileModule;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/mainMenuMobile.js